import { Injectable, Injector } from '@angular/core';
import {
    TemplateLayoutAModel,
    TemplateLayoutBModel,
    TemplateLayoutCModel,
    TemplateLayoutDModel,
    TemplateLayoutEModel,
    TemplateLayoutFModel,
    TemplateLayoutGModel,
    TemplateLayoutHModel,
    TemplateLayoutIModel,
    TemplateLayoutJModel,
    TemplateLayoutKModel,
    TemplateLayoutLModel,
    TemplateLayoutMModel,
    TemplateLayoutModel,
    TemplateLayoutNModel,
} from './template-layout.model';
import { TemplateModel } from './template.model';
import { TemplatePlaceholderModel } from './template-placeholder.model';
import { ITemplatePlaceholder } from './template-layout.model';
import { TemplateControlType } from './types/template-control-type';
import { SimpleTextModelService } from './simple-text.model';
import { ImageItemModelService } from './image-item.model';

import { SiteMapItemModelService } from './site-map-item.model';
import { TemplatePlaceHolderControlModel } from './template-placeholder-control.model';
import { DocumentControlContentLanguageLabelModel } from '../document/document-control-content-language-label.model';
import { AdvancedTextModelService } from './advanced-text.model';
import { BaseItemModelService } from './base-item.model';
import { isDefined } from '@fi-shared/utils/is-defined';
import { isString } from '@fi-shared/utils/is-string';
import { cloneDeep } from '@fi-shared/utils';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { DocumentModel } from '@fi-app/document/document.model';
import { TemplateLayoutHelper } from '@fi-app/template/template-layout-helper';
import { sortArrayByProperty } from '@fi-shared/utils/array-sort-comparators';

@Injectable()
export class TemplateLayoutService {
    constructor(
        private simpleTextItem: SimpleTextModelService,
        private advancedTextItem: AdvancedTextModelService,
        private imageItem: ImageItemModelService,
        private siteMapItem: SiteMapItemModelService,
        private customerDataService: FiCustomerDataService,
        private injector: Injector,
    ) {}

    GetLayout(template: TemplateModel, document?: DocumentModel): TemplateLayoutModel {
        const layoutId = template.BaseUrl;
        const templateLayoutModel: TemplateLayoutModel = (() => {
            switch (layoutId) {
                case 'A':
                    return new TemplateLayoutAModel();
                case 'B':
                    return new TemplateLayoutBModel();
                case 'C':
                    return new TemplateLayoutCModel();
                case 'D':
                    return new TemplateLayoutDModel();
                case 'E':
                    return new TemplateLayoutEModel();
                case 'F':
                    return new TemplateLayoutFModel();
                case 'G':
                    return new TemplateLayoutGModel();
                case 'H':
                    return new TemplateLayoutHModel();
                case 'I':
                    return new TemplateLayoutIModel();
                case 'J':
                    return new TemplateLayoutJModel();
                case 'K':
                    return new TemplateLayoutKModel();
                case 'L':
                    return new TemplateLayoutLModel();
                case 'M':
                    return new TemplateLayoutMModel();
                case 'N':
                    return new TemplateLayoutNModel();
                default:
                    return undefined;
            }
        })();
        if (templateLayoutModel) {
            templateLayoutModel.templateLayoutHelper = new TemplateLayoutHelper(template, document, this.injector);
        }

        return templateLayoutModel;
    }

    LayoutToTemplatePlaceHolderCollection(layout: TemplateLayoutModel, Template: TemplateModel) {
        const result: TemplatePlaceholderModel[] = [];
        let i = 0;
        layout.placeholders.forEach((item) => {
            if (item.children) {
                item.children.forEach((childItem) => {
                    result.push(
                        this.CreateTemplatePlaceholderFromLayoutItem(childItem, Template.PlaceHolderCollection[i]),
                    );
                    i++;
                });
            } else {
                result.push(this.CreateTemplatePlaceholderFromLayoutItem(item, Template.PlaceHolderCollection[i]));
                i++;
            }
        });
        return result;
    }

    CreateTemplatePlaceholderFromLayoutItem(item: ITemplatePlaceholder, placeholder: TemplatePlaceholderModel) {
        const result = placeholder ? placeholder : new TemplatePlaceholderModel(this.customerDataService.customerData);
        result.ControlCollection = [];
        let i = 0;
        item.items.forEach((layoutItem) => {
            const saveModel: TemplatePlaceHolderControlModel = cloneDeep(layoutItem.model);
            saveModel.Settings.SortOrder = i++;
            saveModel.Settings = <any>JSON.stringify(saveModel.Settings);
            saveModel.ControlType = layoutItem.controlId;
            saveModel.Contents.forEach((content) => {
                content.Value = <any>JSON.stringify(content.Value);
            });
            result.ControlCollection.push(<any>saveModel);
        });
        return result;
    }

    /*private addItemToPlaceholderCollection(items: BaseItemModelService[], newItem: BaseItemModelService)
    {
        const index = newItem.model.Settings.SortOrder || 0;
        if (isDefined(items[index]))
        {
            items.push(newItem);
        }
        else
        {
            items[index] = newItem;
        }
    };*/

    TemplatePlaceHolderCollectionToLayout(
        TemplatePlaceHolderCollection: TemplatePlaceholderModel[],
        layout: TemplateLayoutModel,
    ) {
        let i = 0;
        let lastItem: ITemplatePlaceholder;
        layout.placeholders.forEach((item) => {
            if (item.children) {
                item.children.forEach((childItem) => {
                    childItem.items = [];

                    const placeholder = TemplatePlaceHolderCollection[i];
                    if (isDefined(placeholder)) {
                        childItem.items = this.getTemplateLayoutItems(placeholder.ControlCollection);
                    }

                    i++;
                    lastItem = childItem;
                });
            } else {
                item.items = [];
                const placeholder = TemplatePlaceHolderCollection[i];
                if (isDefined(placeholder)) {
                    item.items = this.getTemplateLayoutItems(TemplatePlaceHolderCollection[i].ControlCollection);
                }
                i++;
                lastItem = item;
            }
        });
        if (TemplatePlaceHolderCollection.length > i) {
            for (; i < TemplatePlaceHolderCollection.length; i++) {
                TemplatePlaceHolderCollection[i].ControlCollection.forEach((model) => {
                    const templateLayoutItem: BaseItemModelService = this.CreateTemplateLayoutItemForModel(model);
                    lastItem.items.push(templateLayoutItem);
                });
            }
        }
    }

    private getTemplateLayoutItems(templatePlaceHolderControls: TemplatePlaceHolderControlModel[]) {
        const layoutItemData: {
            item: BaseItemModelService;
            sortOrder: number;
        }[] = [];

        templatePlaceHolderControls.forEach((model) => {
            const templateLayoutItem: BaseItemModelService = this.CreateTemplateLayoutItemForModel(model);

            // for debug
            //this.writeDebugInfo(1, templateLayoutItem);

            layoutItemData.push({
                item: templateLayoutItem,
                sortOrder: model.Settings.SortOrder || 0,
            });
        });

        sortArrayByProperty(layoutItemData, (item) => item.sortOrder);
        return layoutItemData.map((x) => x.item);
    }

    GetLayoutItemPrototypeByControlType(ControlType: TemplateControlType): BaseItemModelService {
        switch (ControlType) {
            case TemplateControlType.PlainText:
                return <any>this.simpleTextItem;
            case TemplateControlType.Image:
                return <any>this.imageItem;
            case TemplateControlType.HtmlText:
                return <any>this.advancedTextItem;
            case TemplateControlType.SiteMap:
                return <any>this.siteMapItem;
        }
    }

    CreateTemplateLayoutItemForModel(model: TemplatePlaceHolderControlModel) {
        const item: BaseItemModelService = cloneDeep(this.GetLayoutItemPrototypeByControlType(model.ControlType));
        if (isString(model.Settings)) {
            model.Settings = JSON.parse(<any>model.Settings);
            model.Contents.forEach((content) => {
                if (isString(content.Value)) {
                    content.Value = JSON.parse(<any>content.Value);
                }
            });
        }
        item.model = model;
        return item;
    }

    ApplyDocumentControlContentsToTemplate(
        documentControlContents: DocumentControlContentLanguageLabelModel[],
        template: TemplateModel,
    ) {
        documentControlContents.forEach((controlContent) => {
            let templatePlaceholderControl = template.FindPlaceHolderControlById(controlContent.PlaceHolderControlId);
            if (templatePlaceholderControl) {
                templatePlaceholderControl.Contents.forEach((content) => {
                    if (content.ContentLanguageId == controlContent.ContentLanguageId) {
                        content.Value = controlContent.Value;
                        content.DocumentControlContent = controlContent;
                    }
                });
            }
        });
    }
}
